import { Platform } from 'react-native';
import * as Notifications from 'expo-notifications';
import * as Device from 'expo-device';
import api from '../config/api';

// Configure notification behavior
Notifications.setNotificationHandler({
  handleNotification: async () => ({
    shouldShowAlert: true,
    shouldPlaySound: true,
    shouldSetBadge: false,
  }),
});

export const notificationService = {
  async registerForPushNotifications() {
    if (!Device.isDevice) {
      console.log('Push notifications require a physical device');
      return null;
    }

    const { status: existingStatus } = await Notifications.getPermissionsAsync();
    let finalStatus = existingStatus;

    if (existingStatus !== 'granted') {
      const { status } = await Notifications.requestPermissionsAsync();
      finalStatus = status;
    }

    if (finalStatus !== 'granted') {
      console.log('Push notification permission not granted');
      return null;
    }

    const tokenData = await Notifications.getExpoPushTokenAsync();
    const pushToken = tokenData.data;

    // Send token to backend
    try {
      await api.post('/auth/push-token', { pushToken, platform: Platform.OS });
    } catch (error) {
      console.error('Failed to register push token:', error);
    }

    if (Platform.OS === 'android') {
      Notifications.setNotificationChannelAsync('default', {
        name: 'default',
        importance: Notifications.AndroidImportance.MAX,
        vibrationPattern: [0, 250, 250, 250],
        lightColor: '#000000',
      });

      Notifications.setNotificationChannelAsync('ride-requests', {
        name: 'Ride Requests',
        importance: Notifications.AndroidImportance.MAX,
        vibrationPattern: [0, 500, 250, 500],
        lightColor: '#4CAF50',
      });
    }

    return pushToken;
  },

  onNotificationReceived(callback) {
    return Notifications.addNotificationReceivedListener(callback);
  },

  onNotificationResponse(callback) {
    return Notifications.addNotificationResponseReceivedListener(callback);
  },

  async sendLocalNotification(title, body, data = {}) {
    await Notifications.scheduleNotificationAsync({
      content: { title, body, data },
      trigger: null,
    });
  },

  async sendRideRequestNotification(ride) {
    await Notifications.scheduleNotificationAsync({
      content: {
        title: 'New Ride Request!',
        body: `${ride.origin} → ${ride.destination}`,
        data: { type: 'ride_request', rideId: ride.id },
      },
      trigger: null,
    });
  },
};
